export function getAsync() {
    // nothing
}

export function setAsync() {
    // nothing
}
